import isStartupDataEnabled from 'bootstrap/lib/isStartupDataEnabled';
import { earlyProcessingForMini } from 'mini-early-processing/lib/earlyProcessingForMini';
import { getMiniAnalyticsOptions } from 'mini-app-analytics';
import { getStartupBootPromise } from 'bootstrap/lib/getStartupBootPromise';
import { handleBootErrorForMini } from 'mini-auth-error-handler/lib/handleBootErrorForMini';
import { LazyAction, LazyBootModule } from 'owa-bundling-light';
import { OwaWorkload } from 'owa-workloads';
import { ServerAppName } from 'data/lib/mini-app-constants';
import { SessionData } from 'owa-service/lib/types/SessionData';
import { sharedStart } from 'owa-shared-start/lib/sharedStart';
import { updateBaseUrlAndHandleAuthError } from 'mini-auth-error-handler/lib/updateBaseUrlAndHandleAuthError';

const lazyModule = new LazyBootModule(
    () => import(/* webpackChunkName: "MailBoot" */ './lazyIndex')
);

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function startMailBootstrap() {
    sharedStart({
        app: ServerAppName.Mini,
        startupAriaToken: getMiniAnalyticsOptions().ariaTenantTokens[0],
        overrideBootPromises: isStartupDataEnabled()
            ? getStartupBootPromise(ServerAppName.Mini)
            : null,
        runAfterRequests: (sessionDataPromise: Promise<SessionData>) => {
            updateBaseUrlAndHandleAuthError(sessionDataPromise);
            earlyProcessingForMini(OwaWorkload.Mail, sessionDataPromise);
        },
        bootstrap: new LazyAction(lazyModule, m => m.bootstrapMailModule),
        handleBootError: handleBootErrorForMini,
    });
}
